import {register} from '../../modules/eventMap.js';
import {makeHandler, initializeWebSocket, initializeSSE} from './handler.js';
import {
    handleTreeViewItemClick,
    loadInitialFileContent
} from './treeViewItemHandler.js';
import {KindeSSEClient} from './websocket-client.js';

const make = () => {
    register('make', {
        start: makeHandler
    });

    register('makeInteractiveEvents', {
        initializeSSE
    });

    register('treeViewItem', {
        handleTreeViewItemClick,
        loadInitialFileContent
    });
};

export {make, makeHandler, handleTreeViewItemClick, loadInitialFileContent};
